"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asRcItems = exports.toItemsFromPath = exports.toItems = exports.toXslxItemProducer = exports.toCsvItemProducer = exports.ItemToTablesConverter = exports.toXlsx = exports.toCsv = exports.getCsvInfoFromString = exports.getCsvInfoFromPath = void 0;
const papaparse = __importStar(require("papaparse"));
const XLSX = __importStar(require("xlsx"));
const type_schema_json_1 = __importDefault(require("@readcube/rcp-meta/type_schema.json"));
const rcp_meta_1 = require("@readcube/rcp-meta");
const rcp_item_validate_1 = require("@readcube/rcp-item-validate");
const parse_authors_string_1 = require("@readcube/parse-authors-string");
const lodash_set_1 = __importDefault(require("lodash.set"));
const lodash_get_1 = __importDefault(require("lodash.get"));
var csvInfo_1 = require("./csvInfo");
Object.defineProperty(exports, "getCsvInfoFromPath", { enumerable: true, get: function () { return csvInfo_1.getCsvInfoFromPath; } });
Object.defineProperty(exports, "getCsvInfoFromString", { enumerable: true, get: function () { return csvInfo_1.getCsvInfoFromString; } });
const headers_1 = __importDefault(require("./headers"));
const specialJanssenMappings_1 = require("./specialJanssenMappings");
const specialLables_1 = require("./specialLables");
const DEFAULT_BASE_APP_URL = "https://app.readcube.com";
const DEFAULT_BASE_WEB_URL = "https://www.readcube.com";
const XLSX_SHEET_NAME = "Papers Export";
const defaultDbg = () => null;
const asString = (a) => Array.isArray(a)
    ? a.join(",")
    : a;
const itemToCsv = ({ headers, item, debug, baseAppUrl, baseWebUrl, customSchema, customFields }) => {
    debug(`Converting item ${item.id}`);
    const typeMeta = customSchema || type_schema_json_1.default;
    let type = customSchema
        ? item?.custom_type
        : item?.item_type;
    type = type || (0, rcp_meta_1.defaultTypeNameFromMapping)(typeMeta);
    const typeDef = typeMeta.types[type];
    if (!typeDef)
        throw new Error("Unknown item type " + type);
    const { fields } = typeDef;
    const customMetaNamesFromType = fields
        .map((f) => typeMeta.field_defs[f])
        .filter((fd) => fd)
        .map((fd) => fd.custom_metadata)
        .filter((cm) => cm);
    const defaultHeadersForCustom = { ...(0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }) };
    if (!customSchema) {
        delete defaultHeadersForCustom["custom_type"];
    }
    const row = Object
        .values(defaultHeadersForCustom)
        .map(h => h.get(item));
    fields.forEach((field) => {
        const fieldDef = typeMeta.field_defs[field];
        let csvLabel = fieldDef.csv || (0, lodash_get_1.default)(fieldDef, 'input.label');
        debug(`label ${csvLabel}`);
        if (!csvLabel)
            return;
        csvLabel = csvLabel.toLowerCase();
        const csvValue = (0, lodash_get_1.default)(item, fieldDef.readcube || `custom_metadata.${fieldDef.custom_metadata}`);
        if (!csvValue)
            return;
        if (!headers.includes(csvLabel))
            headers.push(csvLabel);
        const headerIndex = headers
            .findIndex(h => h.toLowerCase() === csvLabel.toLowerCase());
        debug(`header ${csvLabel} index ${headerIndex}: ${headers[headerIndex]}`);
        if (!headerIndex)
            throw new Error(`Could not find header ${csvLabel}`);
        row[headerIndex] = asString(csvValue);
    });
    item
        && item.custom_metadata
        && Object
            .entries(item.custom_metadata)
            .filter(([key, value]) => !customMetaNamesFromType.includes(key))
            .forEach(([key, value]) => {
            key = key.toLowerCase();
            debug(`Extra custom metadata ${key}:${value}`);
            if (!headers.includes(key))
                headers.push(key);
            const headerIndex = headers.findIndex(h => h === key);
            if (!headerIndex)
                return;
            row[headerIndex] = asString(value);
        });
    return row;
};
const BASIC_HEADERS = ['doi', 'title', 'pmid', 'pmcid', 'arxiv'];
const csvToItem = ({ csvHeaders, row, baseAppUrl, baseWebUrl, csvMapping, debug, customSchema, customFields, allowCopyrightStatus }) => {
    if (!row || (row.length === 1 && (row[0] == null || row[0] == '')))
        return { success: false, errors: ["Empty row"] };
    const defaultHeadersForCustom = Object.fromEntries(Object
        .entries((0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }))
        .map(([key, value]) => [key.toLowerCase(), value]));
    Object
        .entries(specialLables_1.specialLabels)
        .forEach(entry => {
        const [alias, originalHeader] = entry;
        const mapper = defaultHeadersForCustom[originalHeader];
        if (mapper)
            defaultHeadersForCustom[alias.toLowerCase()] = mapper;
    });
    if (!customSchema) {
        delete defaultHeadersForCustom['custom_type'];
    }
    const typeHeaderColumnIndex = csvHeaders
        .findIndex((r) => r.toLowerCase() === 'type');
    let type = 'article' || (0, rcp_meta_1.defaultTypeNameFromMapping)(type_schema_json_1.default);
    let customType;
    const item = { item_type: 'article' };
    if (typeHeaderColumnIndex != -1) {
        const typeCandidate = row[typeHeaderColumnIndex];
        if (typeCandidate && typeCandidate != '')
            type = typeCandidate;
    }
    if (customSchema) {
        debug(`Custom schema library.`);
        const customTypeHeaderColumnIndex = csvHeaders
            .findIndex((r) => r.toLowerCase() === 'custom_type');
        if (customTypeHeaderColumnIndex != -1) {
            const customTypeCandidate = row[customTypeHeaderColumnIndex];
            customType = customTypeCandidate;
        }
        customType ||= (0, rcp_meta_1.defaultTypeNameFromMapping)(customSchema);
        debug(`Custom type: ${customType}`);
    }
    debug(`Type: ` + type);
    debug(`Converting row to item: \n${JSON.stringify(row, null, 2)} `);
    const rowHasAtLeastOneOfRequiredHeaders = BASIC_HEADERS
        .map(h => csvHeaders.includes(h))
        .includes(true);
    if (!csvMapping && !rowHasAtLeastOneOfRequiredHeaders)
        return {
            success: false,
            errors: [`Cannot create item as it doesn't have a at least one of columns: ${BASIC_HEADERS.join(',')}`]
        };
    const defaultHeaderAllowsMutation = (hm) => hm.set;
    const findHeaderIndexForName = (name) => csvHeaders
        .findIndex((r) => r.toLowerCase() === name.toLowerCase());
    Object
        .entries(defaultHeadersForCustom)
        .filter(([name, hm]) => defaultHeaderAllowsMutation(hm))
        .forEach(([name, hm]) => {
        if (!allowCopyrightStatus && name === "copyright status")
            return;
        const csvMappingEntry = csvMapping
            ?.find(csvMapping => csvMapping.papersField?.toLowerCase() === name.toLowerCase());
        if (csvMappingEntry) {
            const mappingHeaderIndex = findHeaderIndexForName(csvMappingEntry.key);
            if (mappingHeaderIndex > -1) {
                hm?.set?.(item, row[mappingHeaderIndex]);
                return;
            }
        }
        const nameHeaderIndex = findHeaderIndexForName(name);
        if (nameHeaderIndex != -1)
            hm?.set?.(item, row[nameHeaderIndex]);
    });
    const metaForMapping = customSchema || type_schema_json_1.default;
    let typeForMapping = customType || type;
    if (!metaForMapping.types[typeForMapping])
        typeForMapping = (0, rcp_meta_1.defaultTypeNameFromMapping)(metaForMapping);
    const fieldDefsByLabel = metaForMapping
        .types[typeForMapping]
        .fields
        .reduce((acc, field) => {
        const fieldDef = metaForMapping.field_defs[field];
        const fieldDefHasLabel = fieldDef?.input?.label;
        if (!fieldDefHasLabel)
            return acc;
        acc[fieldDef.input.label.toLowerCase()] = fieldDef;
        return acc;
    }, {});
    const labelInDefaultHeaders = (label) => Object
        .keys(defaultHeadersForCustom)
        .includes(label);
    const setItemValue = (fieldDef, value) => {
        if (!fieldDef)
            return;
        if (fieldDef.readcube === "article.authors") {
            if (value?.includes('\n'))
                value = value.split('\n').join(',');
            const authors = (0, parse_authors_string_1.parseAuthors)(value)
                .filter(a => a);
            (0, lodash_set_1.default)(item, fieldDef.readcube, authors);
            return;
        }
        if (fieldDef.readcube)
            (0, lodash_set_1.default)(item, fieldDef.readcube, fieldDef.input.array ? value.split(",").filter(r => r) : value);
        if (fieldDef.custom_metadata)
            (0, lodash_set_1.default)(item, `custom_metadata.${fieldDef.custom_metadata}`, value);
    };
    row
        .forEach((value, index) => {
        let label = csvHeaders[index];
        const csvMappingForIndex = csvMapping
            ?.find(mapping => mapping.key === label);
        debug('csv mapping:' + JSON.stringify(csvMappingForIndex, null, 2));
        let fieldDef;
        if (csvMappingForIndex && csvMappingForIndex.papersField != null) {
            fieldDef = fieldDefsByLabel[csvMappingForIndex.papersField.toLowerCase()];
        }
        if (csvMappingForIndex && csvMappingForIndex.customField != null) {
            const customField = customFields
                ?.find((customField) => customField.display === csvMappingForIndex.customField);
            if (customField) {
                debug('for label:' + label);
                debug('found custom field mapping: ' + JSON.stringify(csvMappingForIndex.customField));
                (0, lodash_set_1.default)(item, `custom_metadata.${customField.field}`, value);
                return;
            }
        }
        if (!fieldDef && customSchema) {
            const special = specialJanssenMappings_1.specialJanssenMappings.find(sj => sj.label === label);
            if (special) {
                (0, lodash_set_1.default)(item, special.rcPath, value);
                return;
            }
        }
        const isDefaultHeader = labelInDefaultHeaders(label.toLowerCase());
        if (!fieldDef && isDefaultHeader)
            return;
        label = label.toLowerCase();
        fieldDef = fieldDef ?? fieldDefsByLabel[label];
        debug('for label:' + label);
        debug('found: ' + JSON.stringify(fieldDef, null, 2));
        fieldDef
            ? setItemValue(fieldDef, value)
            : (0, lodash_set_1.default)(item, `custom_metadata.${label}`, value);
    });
    const patentMeta = customSchema || type_schema_json_1.default;
    const setItemTypeToPatent = typeHeaderColumnIndex === -1
        && (patentMeta && Object.keys(patentMeta.types).includes('patent'))
        && item?.ext_ids?.patent_id != null;
    if (setItemTypeToPatent) {
        item.item_type = "patent";
    }
    item.item_type ||= (0, rcp_meta_1.defaultTypeNameFromMapping)(type_schema_json_1.default);
    if (customSchema)
        item.custom_type ||= (0, rcp_meta_1.defaultTypeNameFromMapping)(customSchema);
    const validationResult = (0, rcp_item_validate_1.validate)({ item, customSchema });
    if (!validationResult.valid)
        return { success: false, errors: validationResult.errors };
    return item.id
        ? { success: true, item, action: "update", errors: validationResult.errors }
        : { success: true, item, action: "create", errors: validationResult.errors };
};
const getOpts = (opts) => {
    const debug = opts?.debug || defaultDbg;
    const delimiter = opts?.delimiter || ",";
    const csvMapping = opts?.csvMapping;
    const customSchema = opts?.customSchema;
    const customFields = opts?.customFields;
    const baseAppUrl = opts?.baseAppUrl ?? DEFAULT_BASE_APP_URL;
    const baseWebUrl = opts?.baseWebUrl ?? DEFAULT_BASE_WEB_URL;
    const allowCopyrightStatus = opts?.allowCopyrightStatus || false;
    return { debug, delimiter, csvMapping, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus };
};
const toCsv = (rcItems, opts) => {
    const { debug, delimiter, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus } = getOpts(opts);
    const defaultHeadersForCustom = { ...(0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }) };
    if (!customSchema) {
        delete defaultHeadersForCustom["custom_type"];
    }
    if (!allowCopyrightStatus) {
        delete defaultHeadersForCustom["Copyright status"];
    }
    const headers = Object.keys(defaultHeadersForCustom);
    const rows = rcItems
        .map((item) => itemToCsv({ headers, item, baseAppUrl, baseWebUrl, debug, customSchema, customFields }));
    return papaparse.unparse([headers, ...rows]);
};
exports.toCsv = toCsv;
const toXlsx = (rcItems, opts) => {
    const { debug, delimiter, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus } = getOpts(opts);
    const defaultHeadersForCustom = { ...(0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }) };
    if (!customSchema) {
        delete defaultHeadersForCustom["custom_type"];
    }
    if (!allowCopyrightStatus) {
        delete defaultHeadersForCustom["Copyright status"];
    }
    const headers = Object.keys(defaultHeadersForCustom);
    const rows = rcItems
        .map((item) => itemToCsv({ headers, item, baseAppUrl, baseWebUrl, debug, customSchema, customFields }));
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, XLSX_SHEET_NAME);
    return XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
};
exports.toXlsx = toXlsx;
class ItemToTablesConverter {
    constructor(opts) {
        this.headers = [];
        this.rows = [];
        this.addItems = (items) => {
            for (const item of items) {
                this.rows.push(itemToCsv({
                    item,
                    headers: this.headers,
                    baseAppUrl: this.baseAppUrl,
                    baseWebUrl: this.baseWebUrl,
                    debug: this.debug,
                    customSchema: this.customSchema,
                    customFields: this.customFields,
                }));
            }
        };
        this.getCsv = () => {
            return papaparse.unparse([this.headers, ...this.rows]);
        };
        this.getXlsx = () => {
            const worksheet = XLSX.utils.aoa_to_sheet([this.headers, ...this.rows]);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, XLSX_SHEET_NAME);
            return XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
        };
        const { debug, delimiter, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus } = getOpts(opts);
        this.debug = debug;
        this.delimiter = delimiter;
        this.customSchema = customSchema;
        this.customFields = customFields;
        this.baseAppUrl = baseAppUrl;
        this.baseWebUrl = baseWebUrl;
        const defaultHeadersForCustom = { ...(0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }) };
        if (!customSchema) {
            delete defaultHeadersForCustom["custom_type"];
        }
        if (!allowCopyrightStatus) {
            delete defaultHeadersForCustom["Copyright status"];
        }
        this.headers = Object.keys(defaultHeadersForCustom);
    }
}
exports.ItemToTablesConverter = ItemToTablesConverter;
const toCsvItemProducer = async (itemProducer, path, opts) => {
    const { debug, delimiter, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus } = getOpts(opts);
    const defaultHeadersForCustom = { ...(0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }) };
    if (!customSchema) {
        delete defaultHeadersForCustom["custom_type"];
    }
    if (!allowCopyrightStatus) {
        delete defaultHeadersForCustom["Copyright status"];
    }
    const headers = Object.keys(defaultHeadersForCustom);
    let rows = [];
    let item = await itemProducer();
    while (item) {
        rows.push(itemToCsv({ headers, item, baseAppUrl, baseWebUrl, debug, customSchema, customFields }));
        item = await itemProducer();
    }
    const csvString = papaparse.unparse([headers, ...rows]);
    const fs = require('fs');
    fs.writeFileSync(path, csvString);
};
exports.toCsvItemProducer = toCsvItemProducer;
const toXslxItemProducer = async (itemProducer, path, opts) => {
    const { debug, delimiter, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus } = getOpts(opts);
    const defaultHeadersForCustom = { ...(0, headers_1.default)({ urls: { baseAppUrl, baseWebUrl } }) };
    if (!customSchema) {
        delete defaultHeadersForCustom["custom_type"];
    }
    if (!allowCopyrightStatus) {
        delete defaultHeadersForCustom["Copyright status"];
    }
    const headers = Object.keys(defaultHeadersForCustom);
    let rows = [];
    let item = await itemProducer();
    while (item) {
        rows.push(itemToCsv({ headers, item, baseAppUrl, baseWebUrl, debug, customSchema, customFields }));
        item = await itemProducer();
    }
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, XLSX_SHEET_NAME);
    const buffer = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
    const fs = require('fs');
    fs.writeFileSync(path, buffer);
};
exports.toXslxItemProducer = toXslxItemProducer;
const toItems = (csvString, opts) => {
    try {
        const { debug, delimiter, csvMapping, customSchema, customFields, baseAppUrl, baseWebUrl, allowCopyrightStatus } = getOpts(opts);
        const parseResult = papaparse.parse(csvString);
        const [header, ...rows] = parseResult.data;
        const items = rows
            .filter((row) => row.length > 0)
            .map(row => csvToItem({ csvHeaders: header, row, baseAppUrl, baseWebUrl, csvMapping, customSchema, customFields, debug, allowCopyrightStatus }));
        return { success: true, result: items };
    }
    catch (error) {
        return { success: false, error };
    }
};
exports.toItems = toItems;
const toItemsFromPath = (path, opts) => {
    try {
        const fs = require('fs');
        const csvString = fs.readFileSync(path, 'utf-8');
        return (0, exports.toItems)(csvString, opts);
    }
    catch (error) {
        return { success: false, error };
    }
};
exports.toItemsFromPath = toItemsFromPath;
// web app compatibility
const asRcItems = async (csvString, opts) => {
    const result = (0, exports.toItems)(csvString, opts);
    if (!result.success)
        throw result.error;
    const itemResults = result.result;
    const wrappedItemResults = itemResults.reduce((wrappedResults, result) => {
        if (result.success) {
            wrappedResults.rcItems.push(result.item);
        }
        else {
            wrappedResults.errors = [...wrappedResults.errors, ...result.errors];
            wrappedResults.prettyErrors = [...wrappedResults.errors, ...result.errors];
        }
        return wrappedResults;
    }, {
        rcItems: [],
        items: [],
        errors: [],
        warns: [],
        prettyErrors: [],
        prettyWarns: [],
    });
    return wrappedItemResults;
};
exports.asRcItems = asRcItems;
